<div class="view-header">
  <div class="view-header__wrapper">
    <button
      tuiIconButton
      type="button"
      [appearance]="isDesktop ? 'grey-button' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      (click)="onClickBackButton()"
    ></button>

    <div class="view-header__title">
      <div class="breadcrumbs">
        <ng-container *ngFor="let item of breadcrumbs; let index = index">
          <app-link
            [routerLink]="item.routerLink"
            [queryParams]="item.queryParams"
            [displayText]="item.caption"
            [class.text_truncate]="index === breadcrumbs.length - 1"
          ></app-link>
          <span *ngIf="index < breadcrumbs.length - 1">/</span>
        </ng-container>

        <ng-container *ngIf="isDesktop">
          <span>/</span>
          <span class="breadcrumbs__title">{{ title }}</span>
        </ng-container>
      </div>
    </div>

    <div class="view-header__action-buttons">
      <ng-container *ngIf="isDesktop">
        <lp-statistics-button
          *ngIf="screenType !== 'medium' && allowedProductStatisticsViewing"
          (buttonClick)="onMenuClick('statistics')"
        ></lp-statistics-button>

        <button
          *ngIf="isExtraLargeScreen && allowedPublishing"
          tuiButton
          type="button"
          size="l"
          appearance="white-button"
          (click)="action.emit('publish')"
        >
          {{ 'components.loyaltyViewHeader.buttons.publish' | translate }}
        </button>

        <button
          *ngIf="screenType !== 'medium' && allowedEditing"
          tuiButton
          type="button"
          size="l"
          (click)="action.emit('edit')"
        >
          {{ 'common.buttons.edit' | translate }}
        </button>
      </ng-container>

      <div
        *ngIf="
          isPublishDropdownActionVisible ||
          isEditDropdownActionVisible ||
          isUnPublishDropdownActionVisible ||
          allowedDeleting
        "
        tuiDropdownAlign="left"
        [tuiDropdown]="dropdown"
        [(tuiDropdownOpen)]="showMenu"
      >
        <button
          tuiIconButton
          type="button"
          [appearance]="isDesktop ? 'white-button' : 'flat'"
          [size]="isDesktop ? 'l' : 'm'"
          [iconStart]="'@tui.ellipsis'"
        ></button>
      </div>
    </div>
  </div>
</div>

<ng-template #dropdown>
  <tui-data-list class="view-header__menu-dropdown">
    <button *ngIf="isStatisticsDropdownActionVisible" tuiOption (click)="onMenuClick('statistics')">
      {{ 'common.buttons.statistics' | translate }}
    </button>
    <button *ngIf="isPublishDropdownActionVisible" tuiOption (click)="onMenuClick('publish')">
      {{ 'components.loyaltyViewHeader.buttons.publish' | translate }}
    </button>
    <button *ngIf="isEditDropdownActionVisible" tuiOption (click)="onMenuClick('edit')">
      {{ 'common.buttons.edit' | translate }}
    </button>
    <button *ngIf="isUnPublishDropdownActionVisible" tuiOption (click)="onMenuClick('unpublish')">
      {{ 'components.loyaltyViewHeader.buttons.unpublish' | translate }}
    </button>
    <div
      *ngIf="
        (isPublishDropdownActionVisible || isEditDropdownActionVisible || isUnPublishDropdownActionVisible) &&
        allowedDeleting
      "
      class="view-header__menu-dropdown_divider"
    ></div>
    <button
      tuiOption
      *ngIf="allowedDeleting"
      (click)="onMenuClick('delete')"
      class="view-header__menu-dropdown_delete-btn"
    >
      {{ 'components.loyaltyViewHeader.buttons.deleteAd' | translate }}
    </button>
  </tui-data-list>
</ng-template>
